<template>
    <nav class="navbar navbar-expand-lg navbar-dark main-navbar py-lg-0">
        <div class="container px-md-0">
            <inertia-link class="navbar-brand" :href="route('nl.employerdashboard.dashboard', this.$page.props.auth.user.selected_company.uuid)">
                <img src="/img/logo-white.svg">
            </inertia-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTop" aria-controls="navbarTop" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarTop">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item" v-if="!$page.props.is_blackout" :class="isUrl(route('nl.employerdashboard.dashboard', $page.props.auth.user.selected_company.uuid))? 'active' : ''">
                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.dashboard', $page.props.auth.user.selected_company.uuid)">
                            {{ Lang.get('employerdashboard::shared.top_nav.dashboard') }}
                        </inertia-link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_blackout" :class="isUrl(route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)) ? 'active' : ''">
                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)">
                            {{ Lang.get('employerdashboard::shared.top_nav.employees') }}
                        </inertia-link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_blackout" :class="isUrl(route('nl.employerdashboard.invoices.overview', $page.props.auth.user.selected_company.uuid)) ? 'active' : ''">
                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.invoices.overview', $page.props.auth.user.selected_company.uuid)">
                            {{ Lang.get('employerdashboard::shared.top_nav.invoices') }}
                        </inertia-link>
                    </li>
                    <li class="nav-item" v-if="!$page.props.is_blackout" :class="isUrl(route('nl.employerdashboard.analytics.overview', $page.props.auth.user.selected_company.uuid)) ? 'active' : ''">
                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.analytics.overview', $page.props.auth.user.selected_company.uuid)">
                            {{ Lang.get('employerdashboard::shared.top_nav.analytics') }}
                        </inertia-link>
                    </li>

                    <li class="nav-item" v-if="$page.props.auth.user.companies.length === 0">
                        <span class="nav-link font-aileron-semibold">{{ truncate($page.props.auth.user.selected_company.title) }}</span>
                    </li>

                    <li class="nav-item dropdown ml-0 ml-md-4" v-if="$page.props.auth.user.companies.length">
                        <a class="nav-link font-aileron font-size-14 line-height-24 dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img src="/img/employer-dashboard/icon-account.svg" class="mr-1">
                            <span class="company-name text-ellipsis text-nowrap d-inline-block d-md-none d-lg-inline-block">{{ truncate($page.props.auth.user.selected_company.title) }}</span>
                        </a>
                        <div class="dropdown-menu py-0" aria-labelledby="navbarDropdown">
                            <div class="dropdown-header font-size-14 font-poppins font-weight-medium color-blue py-2">
                                {{ Lang.get('employerdashboard::shared.top_nav.select_different_account') }}
                            </div>
                            <template v-for="company in $page.props.auth.user.companies">
                                <div class="dropdown-divider my-0 py-0"></div>
                                <a class="dropdown-item py-2 font-size-14 font-poppins font-weight-light" :class="{'disabled': !company.active, 'bg-light-gray': !company.active}" :href="route('nl.employerdashboard.dashboard', company.uuid)">
                                    <div class="d-flex justify-content-between" >
                                        <div >{{ company.title }}</div>
                                        <div v-if="!company.active" class="pl-1"><i class="fas fa-exclamation-triangle"></i></div>
                                    </div>
                                </a>
                            </template>
                        </div>
                    </li>
                    <!-- This is Temporary Disabled https://jira.edubookers.com/browse/DLRV2-174 -->
<!--                    <li class="nav-item" :class="isUrl(route('nl.employerdashboard.support.overview', $page.props.auth.user.selected_company.uuid)) ? 'active' : ''">-->
<!--                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.support.overview', $page.props.auth.user.selected_company.uuid)">-->
<!--                            <img src="/img/employer-dashboard/icon-question.svg" class="mr-1 mr-md-0">-->
<!--                            <span class="d-inline-block d-md-none">-->
<!--                                {{ Lang.get('employerdashboard::shared.top_nav.support') }}-->
<!--                            </span></inertia-link>-->
<!--                    </li>-->
                    <li class="nav-item" v-if="!$page.props.is_blackout" :class="isUrl(route('nl.employerdashboard.settings.overview', $page.props.auth.user.selected_company.uuid)) ? 'active' : ''">
                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.settings.overview', $page.props.auth.user.selected_company.uuid)">
                            <img src="/img/employer-dashboard/icon-settings.svg" class="mr-1 mr-md-0">
                            <span class="d-inline-block d-md-none">
                                {{ Lang.get('employerdashboard::shared.top_nav.settings') }}
                            </span></inertia-link>
                    </li>
                    <li class="nav-item">
                        <inertia-link class="nav-link font-aileron-semibold" :href="route('nl.employerdashboard.logout')">
                            <img src="/img/employer-dashboard/icon-logout.svg" class="mr-1 mr-md-0">
                            <span class="d-inline-block d-md-none">
                                {{ Lang.get('employerdashboard::shared.top_nav.logout') }}
                            </span>
                        </inertia-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {

    props: {
        url: String,
    },
    methods: {
        isUrl(...urls) {
            if (urls[0] === '') {
                return this.url === ''
            }
            return urls.filter(url => this.url.startsWith(url)).length;
        },
        home() {
            return location.host;
        },
        truncate(string, maxTextLength = 15) {
            if (string.length <= maxTextLength) { return string; }
            return `${string.substring(0, maxTextLength)} ...`
        },
    },
}
</script>
